import { css } from 'styled-components';

import {
  Body2XSmallSemiBold,
  BodySmallRegular,
  BodyXSmallSemiBold,
} from '@xemplo/style-constants';

import { InputSize } from '../xemplo-input.types';

export const inputSpecificStyles = css`
  &::placeholder {
    color: var(--input-placeholder-text-color);
  }

  &:focus {
    outline: none;
  }
`;

export const inputBaseStyles = css`
  ${BodySmallRegular};
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border: none;

  padding: 0;
  background: inherit;
  align-self: flex-end;
  color: var(--input-text-color);
`;

/**
 * The floating label styling.
 *
 * NOTE: This is being done here so it can tap into
 * the input built-in pseudo elements like `:focus`
 */
export const inputFloatingLabelStyles = css`
  &.${InputSize.Spacious} {
    &:is(:focus, .has-placeholder, .has-value) {
      + label {
        ${BodyXSmallSemiBold};
        top: 10px;
      }
    }
  }

  &.${InputSize.Default} {
    &:is(:focus, .has-placeholder, .has-value) {
      &.has-label {
        margin-bottom: -8px;
      }
      + label {
        ${Body2XSmallSemiBold};
        top: 6px;
      }
    }
  }
`;

export const inputElStyles = css`
  ${inputBaseStyles};
  ${inputSpecificStyles};
  ${inputFloatingLabelStyles};
`;
